module.exports = __webpack_public_path__ + "assets/img/close-circle@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/close-circle@3x.png
// module id = 1934
// module chunks = 0